import qs from 'query-string';
import { sapiPublisherOf } from '@cbs-mp/brands-config';

import { getChangePaymentFlowSource } from '../constants/subscriptionSources';

const spidConfig = CONFIG.spid;
const { basePath, subPagesPaths, assetsPath, myPage } = CONFIG;

export const getCurrentUrl = ({ basename = '', pathname = '' }) => {
    if (typeof window !== 'undefined') {
        return `${window.location.protocol}//${window.location.host}${basename}${pathname}`;
    }

    return null;
};

export const getUrlWithAllowedParams = (path, queryParamsWhiteList = []) => {
    const url = `${window.location.protocol}//${window.location.host}${basePath}${path}`;
    if (queryParamsWhiteList.length === 0) {
        return url;
    }
    const allParams = qs.parse(window.location.search);

    const allowedParams = Object.keys(allParams).reduce((paramsAccumulator, param) => ({
        ...paramsAccumulator,
        ...(queryParamsWhiteList.includes(param) ? { [param]: allParams[param] } : {}),
    }), {});

    return qs.stringify(allowedParams) ? `${url}?${qs.stringify(allowedParams)}` : url;
};

export const getFullUrlTo = path => getUrlWithAllowedParams(path);

export const getStaticFilePath = path => (`${assetsPath}${path}`.replace('//', '/'));

export const getIconFilePath = name => getStaticFilePath(`/icons/${name}.svg`);

export const getQueryStringParams = () => qs.parse(window.location.search);

export const getNewChangePaymentMethodUrl = ({ subscription, userId }) => {
    let publisher;

    try {
        publisher = sapiPublisherOf(subscription.publication);
    } catch (error) {
        publisher = sapiPublisherOf(myPage.publication);
    }

    return `${myPage.urls.newChangePaymentFlowUrl}?${qs.stringify({
        client_id: subscription.clientId,
        subscription_id: subscription.id,
        mypage_client_id: spidConfig.clientId,
        publisher,
        subscription_source: getChangePaymentFlowSource(subscription.source),
        redirect_uri: getCurrentUrl({
            basename: basePath,
            pathname: subPagesPaths?.subscriptions || '',
        }),
        ...(userId && { login_hint: userId }),
    })}`;
};
